import { atom } from 'jotai';
import { atomEmptyNull } from 'utils/atomUtils';

export const renterInsurerCompanyAtom = atomEmptyNull<'buoy'>();
export const accountCompletedAtom = atom<boolean>(false);
